module.exports = require("core-js/modules/es.string.search.js");